// Author LiangGangQiang
// Date 2021-08-21 11:38:57

class SithMesPrdManBorrowProcess {
constructor({
        id = null,
        status = '',
        workOrderCode = '',
        locationId = '',
        borrowUser = '',
        borrowReason = '',
        borrowDateFrom = '',
        borrowDateTo = '',
        toLocationId = '',
        approveUser = '',
        approveBy = '',
        approveDate = '',
        returnDate = '',
        remark = ''}
= {}) {
    this.id = id;
    this.status = status;
    this.workOrderCode = workOrderCode;
    this.locationId = locationId;
    this.borrowUser = borrowUser;
    this.borrowReason = borrowReason;
    this.borrowDateFrom = borrowDateFrom;
    this.borrowDateTo = borrowDateTo;
    this.toLocationId = toLocationId;
    this.approveUser = approveUser;
    this.approveBy = approveBy;
    this.approveDate = approveDate;
    this.returnDate = returnDate;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdManBorrowProcess();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'statusName',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.grid.statusName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'workOrderCode',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.grid.workOrderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'createdTime',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.grid.createdTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'createdByName',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.grid.createdByName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationName',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'borrowUserNames',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.grid.borrowUserNames',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'borrowReason',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.grid.borrowReason',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'borrowDateFrom',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.grid.borrowDateFrom',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'borrowDateTo',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.grid.borrowDateTo',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'toLocationName',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.grid.toLocationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'approveUserNames',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.grid.approveUserNames',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'approveByName',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.grid.approveByName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'approveDate',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.grid.approveDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'returnDate',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.grid.returnDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    statusFilter : "",
    workOrderCodeFilter : "",
    createdByNameFilter : "",
    locationIdFilter : "",
    locationNameFilter : "",
    borrowUserFilter : "",
    borrowReasonFilter : "",
    borrowDateFromRteFilter : "",
    borrowDateFromLteFilter : "",
    borrowDateToRteFilter : "",
    borrowDateToLteFilter : "",
    toLocationIdFilter : "",
    toLocationNameFilter : "",
    approveUserFilter : "",
    approveByFilter : "",
    approveByNameFilter : "",
    approveDateRteFilter : "",
    approveDateLteFilter : "",
    returnDateRteFilter : "",
    returnDateLteFilter : "",
    workflowQueryTypeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'statusFilter',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'SithMesPrdManBorrowProcess',statusFilter:1}
        }
        },
        {
        key: 'workOrderCodeFilter',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'createdByNameFilter',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.filter.createdByName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'locationNameFilter',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.filter.locationName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'borrowUserFilter',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.filter.borrowUser',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'borrowReasonFilter',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.filter.borrowReason',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'borrowDateFromRteFilter',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.filter.borrowDateFromRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'borrowDateFromLteFilter',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.filter.borrowDateFromLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'borrowDateToRteFilter',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.filter.borrowDateToRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'borrowDateToLteFilter',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.filter.borrowDateToLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'toLocationNameFilter',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.filter.toLocationName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'approveUserFilter',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.filter.approveUser',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'approveByNameFilter',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.filter.approveByName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'approveDateRteFilter',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.filter.approveDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'approveDateLteFilter',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.filter.approveDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'returnDateRteFilter',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.filter.returnDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'returnDateLteFilter',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.filter.returnDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'locationId',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.entity.locationId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'borrowUser',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.entity.borrowUser',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'borrowReason',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.entity.borrowReason',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'borrowDateFrom',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.entity.borrowDateFrom',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'borrowDateTo',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.entity.borrowDateTo',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'toLocationId',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.entity.toLocationId',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'approveUser',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.entity.approveUser',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'approveBy',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.entity.approveBy',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'approveDate',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.entity.approveDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'returnDate',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.entity.returnDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdManBorrowProcess.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesPrdManBorrowProcess, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
